<template>
    <div class="authentication">
        <!-- 头部 -->
        <headerTail></headerTail>
        <!-- 中间内容 -->
        <div class="containnnn">
            <div class="contain">
                <div class="containDiv">
                  <!-- 左边部分 -->
                  <div class="leftDivDiv">                    
                    <!-- 日历 -->
                    <div class="orderConfirmationDiv">
                        <p class="titletitle">1. 选择使用日期</p>
                        <!-- 日历 -->
                        <div class="calendarsss">
                            <div class="calendarDiv">
                                <div>
                                    <Calendar id="Calendar" ref="Calendar" @choseDay="clickDay" @changeMonth="changeDate" :agoDayHide="agoDayHide" :sundayStart="true" :textTop="textTop"></Calendar>
                                </div>
                                <ul class="remarksUl">
                                    <li><i class="gray"></i>不可选</li>          
                                    <li><i class="lightColor"></i>可选</li>       
                                    <li><i class="todayColor"></i>今日</li>  
                                    <li><i class="dark"></i>已选</li>            
                                </ul>
                                <div class="clear"></div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <!-- 添加购票人信息部分 -->
                    <div class="fromDiv">
                        <p>2. 选择购买数量</p>
                        <div class="inputnum">
                            <span>{{ticketdata.ticketname}}</span>
                            <el-input-number size="medium" :min="1" :step="1" :precision="0" v-model="datas.ordertotal"></el-input-number>
                        </div>
                        <!-- 添加购票人信息 -->
                        <!-- <div class="add"> 
                            <i class="iconfont icon-icon02"></i>添加实名制信息   
                        </div> -->
                        <el-radio v-model="radio" label="1">我已阅读并同意
                            <i @click="centerDialogVisible = true">《购票条款》</i>
                        </el-radio>
                        <!-- <div class="note">
                            <i class="iconfont icon-zhuyiattentionfill"></i>网络购票后，请携带有效证件刷卡入园
                        </div> -->
                    </div>
                  </div>
                  <!-- 右边：当前选择 -->
                  <div class="rightDivDiv">
                      <div class="rightRight">
                        <p class="titletitle newTitle">3. 订单信息确认</p>
                        <ul class="piao">    
                            <li>
                                <div>
                                    <span>票 种：</span>{{ticketdata.ticketname}} * {{datas.ordertotal}} （{{ticketdata.xprice}}元/门票）
                                </div>
                            </li>                    
                            <li>                                                        
                                <div>
                                    <span>预约时间：</span>{{datas.bookdate.replace(/^(\d{4})(\d{2})(\d{2})$/,"$1-$2-$3")}}
                                </div>
                            </li>  
                            <!-- <li>
                                <span>购票手机号：</span>{{TimeValue}}
                                <i class="blueee" @click="DialogPhone=true">更改号码</i>
                            </li>                       -->
                        </ul>
                        <div class="btn">
                            <span>合计<i>{{datas.ordertotal * ticketdata.xprice}} 元</i></span>
                            <el-button type="primary" @click="onSubmit" :loading="loading">确认订单</el-button>
                            <div class="clear"></div>
                        </div>
                      </div>
                  </div>
                  <div class="clear"></div>
                </div>
                <!-- 页尾 -->
                <div class="footerDiv">
                    <div class="left">
                        <span>热线电话：0874-6881555</span>
                        <span style="margin-right:0;">开放时间：08:30-18:30</span>
                        <br>
                        <span>景区地址：云南省曲靖市陆良县城西南20公里</span>
                        <span style="margin-right:0;">邮政编码：655699</span>
                        <br>
                        <span>版权所有：@2018 All Rights Rserved 云南曲靖陆良彩色沙林智慧景区</span>
                    </div>
                    <div class="right">
                        <div style="margin-left:10px">
                            <img src="@/assets/images/wx.jpg" alt="">
                            <p>官网微信</p>
                        </div>
                        <!-- <div>
                            <img src="@/assets/images/wx.jpg" alt="">
                            <p>官方微博</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 页尾 -->
        <!-- <footerTail></footerTail> -->
        <!-- 弹出层 - 购票条款 -->
        <div class="terms">
            <el-dialog title="购票条款" :visible.sync="centerDialogVisible" width="55%" center>
                <ul class="uldiv">
                    <li v-for="(item,index) in loadList" :key="index">
                        <div v-html="item.content"></div>
                    </li>
                </ul>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>           
        </div>
       
        <!-- 弹出层 - 更改手机号码 -->
        <!-- <div class="phoneDiv">
            <el-dialog v-if="DialogPhone" title="手机号验证" :close-on-press-escape=false :close-on-click-modal=false :visible.sync="DialogPhone" width="550px" center>
                <el-form ref="form2" :model="form2" status-icon :rules="rulesphone" label-width="130px">
                    <el-form-item label="验证码" prop="verifycode" class="verifycode">
                        <el-input v-model="form2.verifycode" placeholder="请输入验证码" clearable></el-input> 
                        <i class="iii" @click="getCode">
                            <img :src="imgsrc" alt="">                        
                        </i>                                   
                    </el-form-item> 
                    <el-form-item label="手机号码" prop="phone">
                        <el-input v-model="form2.phone" placeholder="请输入手机号" clearable></el-input>                                 
                        <input type="button" class="code" v-model="codeMsg" @click="getPhones" :disabled="codeDisabled" />                         
                    </el-form-item>                            
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="form2.code" placeholder="请输入验证码" clearable></el-input>
                    </el-form-item>
                     <el-form-item class="phoneDivBtn"> 
                        <el-button type="primary" @click="submitPhone('form2')">确 定</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog> 
        </div>  -->
    </div>
</template>

<script>
import headerTail from "@/components/common/headerTail.vue";
import footerTail from "@/components/common/footerTail.vue";
import Calendar from "vue-calendar-component";
import apiii from "@/api/calendar.js";
import api from "@/api/authentication.js";
import store from "@/vuex/store";
export default {
  name: "authentication",
  data() {   
      var validatePhone=(rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入手机号')); 
         } else {
            //验证手机号码                   
            let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;    //正则匹配手机号码
            if(!reg.test(value)){
                callback(new Error('手机格式不正确'));    
            }else{
                this.showname = true;
                callback();
            }
        }
    };
    var validateCode = (rule, value, callback) => {
        if (value.replace(/(^\s+)|(\s+$)/g,"") === '') {
            callback(new Error('请输入验证码'));
        } else {
            callback();
        }
    };
    var validateVerifycode = (rule, value, callback) => {
        if (value.replace(/(^\s+)|(\s+$)/g,"") === '') {
            callback(new Error('请输入验证码'));
        } else {   
            let reg = /^[A-Za-z0-9]{1,6}$/;      //正则匹配：英文大小写，数字
            if(!reg.test(value)){
                callback(new Error('请输入正确的验证码'));    
                return false
            }                     
            callback();
        }
    };
    return {
      //*******************日历部分*******************
      agoDayHide: "",                    // 某个日期以前的不允许点击，时间戳长度是10位
      futureDayHide: "",                 // 某个日期以后的不允许点击，时间戳长度是10位
      textTop: [],
      time: {                            // 日历时间
        beginDate: "",
        endDate: ""
      },
      true: true,
      options: [],
      TimeValue: "",                     //手机号码
      dataOrder: [],
      noMatchText: "",                   //选择框的选项为空时显示的文字：预约已满，请更换日期
      disabled: true,                    //选择框是否禁用
      placeholder: "",                   //选择框的文字提示
      //*******************/添加购票人信息和当前选择部分*******************
      radio: "0",                          //单选框
      dialogVisible: false,                //弹出层
      centerDialogVisible: false,          //弹出层
      showDialogVisible: false,            //弹出层
      closeModal: false, 
      DialogPhone: false,  
      form2: { phone: "", code: "", verifycode: '' },
      priceType:[' ','平日普通票','平日优惠票','指定日普通票','指定日优惠票'],
      loadList:[],                         // 购票须知
      codeDisabled: false,                 // 是否禁用按钮  
      countdown: 60,                       // 倒计时秒数
      codeMsg: '获取验证码',                // 按钮上的文字
      timer: null,                         // 定时器



      rulesphone: {                       // 验证规则-更改手机号码
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        code: [{ required: true, validator: validateCode, trigger: 'change' }],
        verifycode: [{ required: true, validator: validateVerifycode, trigger: 'blur' }],
      },
      loading: false,  
      /////////////////////
      ticketdata: {},
      datas:{
            bookdate: '',    // 预约时间
            ordertotal: 1,   // 订单数量
            tickettype: '',   // 票类编号        
      }, 
      imgsrc: ''    
    };      
  },   
  store, 
  components: {
    headerTail,
    footerTail,
    Calendar
  },
  created() { 
    //*******************日历部分******************* 
        //前一天的时间戳
        let preDate = new Date(new Date().getTime() - 24*60*60*1000);    
        let atime = preDate.toLocaleDateString().split("/"); // 结果：["2019", "4", "30"]
        let beforeDay = atime[0] + "-" + this.num(atime[1]) + "-" + this.num(atime[2]); // 结果：2019-04-30
        let date = new Date(beforeDay).getTime(); // 转换为时间戳
        //某个日期以前的不允许点击，时间戳长度是10位
        this.agoDayHide = Math.round(date/1000).toString()  
             
        this.ticketfindById(Base64.decode(this.$route.query.id));  // 查询单个票样的信息 
        this.ticketUser();
        this.getCode();
        this.loadNoticeList();
  },
  mounted() {
    this.list();    
  },
  methods: {
    // 查询单个票样的信息
    ticketfindById(id){
        api.ticketfindById(id).then(res=>{
            this.ticketdata = res.data;
            this.datas.tickettype = res.data.ticketsystemid;
        }).catch(error=>{
            console.log(error)
        })
    },
    // 获取手机验证码
    getPhones(){  
        if(this.showname==false || this.form2.verifycode==''){
            this.$message.error('请输入手机号和验证码'); 
            return false
        } 
        api.getPhone(this.form2).then(Response=>{       
            //console.log(Response)  
            this.$message.success('验证码已发送');
            // 验证码60秒倒计时
            if(!this.timer) {
                this.timer = setInterval(() => {
                    if (this.countdown > 0 && this.countdown <= 60) {
                        this.countdown--;
                        if (this.countdown != 0) {
                            this.codeMsg = this.countdown + "s后再获取";
                            this.codeDisabled = true;
                        } else {
                            clearInterval(this.timer);
                            this.codeMsg = '获取验证码';
                            this.countdown = 60;
                            this.timer = null;
                            this.codeDisabled = false;
                        }
                    }
                }, 1000)            
            }              
        }).catch(error=>{
            //console.log(error)
            this.getCode();
        })
    },
    // 确认按钮
    onSubmit() {  
        if(this.datas.bookdate==''){
            this.$message.error('请选择入园日期'); 
            return false
        }
        if(this.radio=='0'){
            this.$message.error('请阅读并同意《购票条款》'); 
            return false
        }
        this.loading = true;
        api.createOrder(this.datas).then(Response=>{              
            this.$message.success('订单保存成功，去付款');   
            this.$router.push('/myOrder')          
        }).catch(error=>{
            this.loading=false;
            console.log(error)
      })
    },       
    //更改手机号码
    submitPhone(formName){
        this.$refs[formName].validate((valid) => {
            if(valid){                           
                //判断验证码是否正确                               
                api.checkCode(this.form2).then(Response=>{               
                    //console.log(Response)
                    this.TimeValue=this.form2.phone; 
                    this.$message.success('更改号码成功'); 
                    setTimeout(() => {                    
                        this.DialogPhone = false;  
                    }, 2000);
                    this.$refs[formName].resetFields();   // 清空表单                                    
                }).catch(error=>{
                    //console.log(error)
                })
            }
        })
    },
    //购票须知
    loadNoticeList(){
        api.loadNoticeList({}).then(Response=>{
            console.log(Response)
            this.loadList=Response.data;
        }).catch(err=>{
            console.log(err)
        })
    },
    //*******************日历部分*******************
    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },
    //日历，选中某天
    clickDay(data) {
      //将选中的日期处理格式
      function num(n) {
        return n < 10 ? "0" + n : "" + n;
      }
      let datess = data.slice(5).split("/");
      this.datas.bookdate = data.slice(0, 4) +'-'+  num(datess[0]) +'-'+  num(datess[1]);
    },
    //日历，左右点击切换月份
    changeDate(data) { 
      this.list();
    },
    list() {
        let Calendar = this.$refs.Calendar;
        setTimeout(() => {
            //获取所有class名字为wh_want_dayhide的元素，并且添加上新的class名字为newgray
            var itemDate = document.getElementsByClassName("wh_want_dayhide");
            for (let i = 0; i < itemDate.length; i++) {
            itemDate[i].classList.add("newgray");
            }
        });
    },
    // 获取验证码
    getCode(){
        this.imgsrc = "https://pay.horti-expo2019.com:8890/ticketAppUser/getVerifyCode?"+Math.random();
    },
    // 查询个人信息
    ticketUser(){
        api.ticketAppUser({}).then(Response=>{
            //console.log(Response)
            this.TimeValue =Response.data.name;
        }).catch(error=>{
            //console.log(error)          
        })
    },
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    "$route": "list"
  }
};
</script>

<style lang="stylus" scoped>
.fl{
    float: left;
}
.clear{
     clear: both;
}
.containnnn{
    background: url('../assets/images/bg.jpg') no-repeat center;
    background-size: cover;
}
.contain {
    // height: 1040px;
    
    .containDiv {
        padding: 88px 66px;
        background: #fff;
        // width: 910px;
        .leftDivDiv{  
            float: left;
            border-right: solid 1px #A37D4C;
            width: 677px;
            padding-bottom: 30px;
        }
        .rightDivDiv{
            float: left;
            margin-left: 50px;
            width: 340px;
            p{
                margin: 0 0 56px 0;
                font-weight: bold;
            }
            .piao{
                font-size: 14px;
                color: #666;
                li{
                    margin-bottom: 20px;
                    .righttt div{
                       margin-bottom: 10px; 
                       text-align: center;
                    }
                    .blueee{
                        margin-left: 20px;
                        color: #2E76E1;
                        cursor: pointer;
                    }
                    span{
                        width: 85px;
                        display: inline-block;
                    }
                }
                
            }
            .btn {
                padding-top: 33px;
                span{
                    float: left;
                    height: 54px;
                    display: inline-block;
                    line-height: 54px;
                    i{
                        color: #EC0A0A;
                        margin-left: 25px;
                        font-weight: bold;
                    }
                }
                .el-button {
                    float: right;
                    background-color: #3a3a3a;
                    border: none;
                    font-size: 16px;
                    padding: 15px 50px;
                    border-radius: 5px;
                    letter-spacing: 1px;
                }
            }
        }
        .title {
            overflow: auto;
            margin-bottom: 68px;

            img {
                float: left;
                margin-right: 34px;
            }

            div {
                float: left;

                p {
                    font-size: 26px;
                    margin-bottom: 14px;
                }

                span {
                    font-size: 18px;
                    color: #999;
                }
            }
        }

        .fromDiv {
            clear: both;
            p {
                font-size: 18px;
                margin-bottom: 35px;
                height: 30px;
                line-height: 30px;
                font-weight: bold;
            }
            .inputnum{
                margin: 0 0 46px 72px;
                .el-input-number{
                    margin-left: 54px;
                }
            }
            .people{
                border-top: 1px dotted #cdcdcd;
                border-bottom: 1px dotted #cdcdcd;
                padding: 25px 0 0 0;
                margin: 0 15px;
                ul li{
                    padding-bottom: 25px;
                    height: 21px;
                    line-height: 21px;
                    color: #666;
                    font-size: 14px;
                    .liDiv{
                        display: inline-block;
                       width: 100%;
                        text-align: center;
                    }
                    .spanDiv{
                        display: inline-block;
                    }
                    .emDiv{
                        display: inline-block;
                    }
                    .deleteSpan{
                        cursor: pointer;
                        color: #969696;
                        width: 100%;
                        display: inline-block;
                        // text-align: center;
                    }
                }
            }
            .add {
                font-size: 14px;
                color: #1c80db;
                padding: 26px 0 52px 40px;
                height: 32px;
                line-height: 32px;
                 cursor: pointer;
                .iconfont {
                    font-size: 30px;
                    float: left;
                    margin-right: 20px;
                }
            }

            .el-radio {
                color: #999;
                margin-left: 40px;
                i {
                    color: #0068b7;
                }
            }

            .note {
                color: #eb1414;
                padding: 20px 0 40px 40px;
                font-size: 14px;
                height: 28px;
                line-height: 28px;

                .iconfont {
                    margin-right: 6px;
                    font-size: 26px;
                    float: left;
                }
            }           
        }
    }
}
.terms {
    .uldiv{
        margin: 0 10px;
        height: 400px;
        overflow: auto;
        border: 1px solid #f3f3f3;
        padding: 30px;
    }
    ol{
        margin: 0;
        li{
            line-height: 2;
            padding-bottom: 5px;
        }
        
    }       
}
.confirm{
    p{
        margin-bottom: 10px;
    }
    .cont{
        div{
            float: left;
        }
        ul{
            float: left;
            li{
                margin-bottom: 10px;
                .liLi{
                        width: 120px;
                        display: inline-block;
                        text-align: center;
                }
                span{
                    width: 270px;
                    display: inline-block;
                }
            }
        }
        .clear{
            clear: both;
        }
    }
    .el-dialog__footer{
        margin-top: 20px;
    }
    
}
.phoneDiv{
    .el-input{
        width: 212px;
    }
    .code{
        margin-left: 10px;
        color: #448aca;
        cursor: pointer;
        border: solid 1px #448aca;
        background-color: #fff;
        height: 30px;
        border-radius: 4px;
    }
    .code:hover{
        background: #909399;
        color: #fff;
        border: solid 1px #909399;
    }
    .phoneDivBtn{
        margin: 40px 0 25px 0;
    }
    .verifycode{
        .iii{
            display: block;
            width: 124px;
            height: 30px; 
            padding: 0 0 0 12px;       
            img{
                width: 100%;
                height: 100%;
                display: inline-block;
            }
        }       
    }
}
//*******************日历部分*******************
.orderConfirmationDiv {
        .titletitle {
            margin: 0 0 45px 0;
            font-weight: bold;
        }

        .newTitle {
            margin-top: 76px;
        }

        .demo-table-expand {
            .people {
                width: 516px;
                padding: 0 0 0 88px;

                ul li {
                    color: #606266;

                    i {
                        padding-right: 80px;
                    }
                }
            }
        }

        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 80%;
        }

        .bearerList li {
            margin-bottom: 10px;

            i {
                margin-right: 15px;
            }
        }

        .btn {
            float: right;
            margin: 60px 24px 0 0;

            span {
                font-size: 18px;

                i {
                    color: #db191d;
                    margin: 0 45px 0 33px;
                }
            }

            .el-button {
                border-radius: 10px;
                padding: 19px 72px;
                background-color: #16365c;
                border: none;
                font-size: 16px;
            }
        }
    }
    .fl {
    float: left;
}

.calendarsss {
    font-size: 14px;

    .calendarDiv {
        .remarksUl{
            margin: 28px 0 54px 100px;
            height: 30px;

            li {
                margin: 0 35px 0 0;
                height: 30px;
                line-height: 30px;
                float: left;
                font-size: 12px;

                i {
                    width: 30px;
                    height: 30px;
                    display: inline-block;
                    border-radius: 8px;
                    margin-right: 10px;
                    float: left;
                }
            }

            .gray {
                background-color: #d6d6d6;
            }

            .lightColor {
                background-color: #E9CDAC;
            }

            .dark {
                background-color: #D89E58;
            }

            .todayColor {
                background-color: #CBB99D;
            }
        }
    }

    .clear {
        clear: both;
    }

    .selectDiv {
        clear: both;
        padding: 50px 0 54px 40px;

        span {
            margin-right: 10px;
        }

        .el-select {
            width: 402px;
        }
        
        p {
            margin-top: 30px;

            i {
                color: #2777e3;
                margin-left: 10px;
            }
        }
    }


    .timeType {
        padding-left: 82px;

        span {
            display: block;
            margin: 15px 0;

            em {
                margin-right: 20px;
            }
        }
    }

    .btn {
        text-align: right;
        margin: 60px 24px 0 0;

        .el-button {
            border-radius: 10px;
            padding: 19px 72px;
            background-color: #16365c;
            border: none;
            font-size: 16px;
        }
    }
}
//页尾
.footerDiv{
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        border-top: 1px solid #987943;
        color: #333;
        width: 100%;
        height: 280px;
        margin: 0 auto;
        margin-top: 40px;
        font-size: 14px;
        .left{
            float: left;
            padding-top: 74px;
            span{
                margin: 0 14px 25px 0;
                display: inline-block;
            }
        }
        .right{
            float: right;
            padding-top: 53px;
            text-align: center;
            >div{
                float: left;
                margin-left: 34px;
                >img{
                    width: 136px;
                }
            }
            p{
                margin-top: 10px;
            }
        }
}

</style>
<style>
.authentication .el-radio__inner {
  width: 19px;
  height: 19px;
  margin-left: 3px;
}
.authentication .addRealName .el-dialog__body{
    padding: 30px 60px 0 30px;
}
.authentication .addRealName .el-form-item__label{
    width: 135px!important;
    color: #333;
}
.authentication .addRealName .el-form-item__content{
    margin-left: 135px!important;
}
.authentication .addRealName .el-select{
    width: 100%;
}
.authentication .addRealName .el-dialog__footer{
    text-align: center;
    padding: 20px 20px 60px;
}
.authentication .addRealName .el-button{
    background-color: #16365c;
    border: none;
    font-size: 16px;
    padding: 15px 60px;
    border-radius: 10px;
    letter-spacing: 2px;   
}

.authentication .el-radio__input.is-checked+.el-radio__label {
    color: #999;
}
/* .authentication .terms .el-dialog--center{
    border-radius: 10px;
} */
.authentication .terms .el-dialog--center .el-dialog__body{
    padding: 15px 35px 30px 20px;
}
.authentication .addRealName .el-form .el-form-item:last-child .el-form-item__content{
    margin: 0!important; 
    text-align: center;
    padding: 20px 0 60px 0;
}
.authentication .confirm .el-button--primary {
    background-color: #16365c!important;
    border-color: #16365c!important;
}
.authentication .phoneDiv .phoneDivBtn .el-form-item__content {
    margin-left: 0!important;
    text-align: center;
}
.authentication .phoneDiv .phoneDivBtn .el-form-item__content .el-button{
    background-color: #16365c;
    border: none;
    font-size: 16px;
    padding: 15px 60px;
    border-radius: 10px;
    letter-spacing: 2px;
}
.authentication .phoneDiv .el-dialog__title{
    display: block;
    text-align: left;
}
.authentication .orderConfirmationDiv table th > .cell {
  text-align: center;
  color: #333;
  padding: 11px 0;
}
.authentication .orderConfirmationDiv table td > .cell {
  text-align: center;
  color: #666;
  padding: 11px 0;
}
.authentication .orderConfirmationDiv .demo-table-expand label {
  margin-left: 48px;
  color: #99a9bf;
}
.authentication .orderConfirmationDiv .wh_content_all {
  background-color: transparent !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_container {
    max-width: 442px !important;
    padding: 0 40px !important;
    margin: 0 0 0 47px;
}
.authentication .orderConfirmationDiv .calendarsss .wh_top_changge li {
  background-color: transparent !important;
  font-size: 18px !important;
  color: #666 !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_jiantou1 {
  border-top: 2px solid #6891da !important;
  border-left: 2px solid #6891da !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_jiantou2 {
  border-top: 2px solid #6891da !important;
  border-right: 2px solid #6891da !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_all .wh_content:nth-child(2) {
  background-color: transparent !important;
  padding: 10px 0 0 0 !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_all .wh_content:nth-child(3) {
  padding: 0;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_all .wh_top_tag {
  color: #666 !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_all .wh_content:nth-child(3) .wh_content_item {
  background-color: #EBCFAD !important;
  margin: 0 3px 3px 0 !important;
  border-radius: 8px;
  width: 60px !important;
  height: 60px !important;
}

.authentication .orderConfirmationDiv .calendarsss .wh_item_date {
  width: 42px !important;
  height: 32px !important;
  line-height: 32px !important;
  color: #666 !important;
  padding: 0 0 28px 18px;
  font-size: 14px !important;
  border-radius: 8px !important;
}

.authentication .orderConfirmationDiv .calendarsss .wh_item_date:hover {
  background: #d89e58 !important;
  border-radius: 8px !important;
}

.authentication .orderConfirmationDiv .calendarsss .wh_content_item .newgray {
  background-color: #d6d6d6 !important;
  cursor: default;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_item .wh_isToday {
  background: #CBB99D !important;
  border-radius: 8px !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_item .wh_chose_day {
  background: #d89e58 !important;
  color: #fff !important;
  border-radius: 8px !important;
}
.authentication .orderConfirmationDiv .calendarsss .wh_content_item .newlightColor {
  background-color: #cfddf0 !important;
}
.authentication .orderConfirmationDiv .containDiv .calendarsss .wh_container {
  max-width: 530px !important;
  margin-left: 82px !important;
}
.authentication .orderConfirmationDiv .wh_container .wh_content_item{
    width: 14.2%!important;
}
.authentication .verifycode .el-form-item__content{
    display: flex!important;
    align-items: center!important;
}
</style>



// WEBPACK FOOTER //
// src/views/Authentication.vue